const Test = async () => {
  return import("../../static_data/airports.json")
}

export default Test
